<template>
  <main class="gs" v-if="step1">
    <section id="gs_top"></section>
    <section id="gs_content">
        <h1>{{ $_getTranslations.visitor_get_started_step1_welcome }}</h1>
        <h2>{{ $_getTranslations.visitor_get_started_step1_the_distinguished }}</h2>
        <p>{{ $_getTranslations.visitor_get_started_step1_prove_intelligence }}</p>
      <base-button
        :container-class="'play'"
        @button:click.prevent="goToStep2"
        >{{ $_getTranslations.visitor_get_started_step1_get_started_button }}</base-button>
    </section>
    <prize-section></prize-section>
  </main>
  <main class="gs2" v-else>
    <section id="gs2_content">
      <p>{{ $_getTranslations.visitor_get_started_prove_intelligence }}</p>
      <p>
        {{ $_getTranslations.visitor_get_started_earn_title }}
        <span>{{ $_getTranslations.visitor_get_started_the_distinguished }}</span><br>
        {{ $_getTranslations.visitor_get_started_get_rewarded }}
      </p>
    </section>
    <section id="btns_sect">
      <base-button
        :container-class="'play'"
        @button:click.prevent="goToRegistration"
      >{{ $_getTranslations.visitor_get_started_register }}</base-button>
      <router-link :to="'login'" class="login_btn">
        {{ $_getTranslations.visitor_get_started_login }}
      </router-link>
      <p class="disclaimer">{{ $_getTranslations.visitor_get_started_disclaimer_text }}</p>
    </section>

    <register-via-sms v-if="isRegisterViaSmsModalOpen"></register-via-sms>
  </main>
</template>

<script>
import IntegrationMixin from '../../common/mixins/integration';
import RegistrationFlowMixin from '../../common/mixins/flow';
import simplifyRegistration from '../../components/home/modals/SimplifyRegistration';
import VisitorWinners from './VisitorWinners';
import PrizeSection from '../common/section/PrizeSection';
import BaseButton from "../common/button/BaseButton";
import RegisterViaSms from '../home/modals/RegisterViaSms.vue'
import translationMixin from "../../common/mixins/translation";
import modals from '../../common/modals'

export default {
  name: 'index',
  mixins: [
    IntegrationMixin,
    RegistrationFlowMixin,
    translationMixin
  ],
  components: {
    BaseButton,
    PrizeSection,
    VisitorWinners,
    simplifyRegistration,
    RegisterViaSms,
  },
  props: ['freePlayButton'],
  data() {
    return {
      step1: true,
      isRegisterViaSmsModalOpen: false
    };
  },
  methods: {
    goToStep2() {
      this.step1 = false;
    },
    goToRegistration() {
      if (!this.hasWebRegister()) {
        this.isRegisterViaSmsModalOpen = true;
        modals.setupCommonModal({
          afterHideCallback: () => {
            this.isRegisterViaSmsModalOpen = false;
          }
        });
      } else {
        this.registrationRedirect();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Index.vue